import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import styled, { keyframes } from "styled-components";
import ImageSlider from "../ImageSlider";

import CutOut from "../../../assets/images/Popular/CutOut.jpg";
import TShirt from "../../../assets/images/Popular/TShirt.jpg";
import Mug from "../../../assets/images/Popular/Mug.jpg";
import Board from "../../../assets/images/Popular/NeonBoard.jpg";
import Frame from "../../../assets/images/Popular/Frame.jpg";
import Frame2 from "../../../assets/images/Popular/Frame2.jpg";

// Keyframes for animations
const slideInFromLeft = keyframes`
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
`;

const slideInFromRight = keyframes`
  0% {
    transform: translateX(100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
`;

// Styled components for animated columns
const AnimatedLeftCol = styled(Col)`
  animation: ${({ $inView }) => ($inView ? slideInFromLeft : "none")} 2s
    forwards;
  opacity: ${({ $inView }) => ($inView ? 1 : 0)};
  transition: opacity 2s;
`;

const AnimatedRightCol = styled(Col)`
  animation: ${({ $inView }) => ($inView ? slideInFromRight : "none")} 2s
    forwards;
  opacity: ${({ $inView }) => ($inView ? 1 : 0)};
  transition: opacity 2s;
`;

function HomeSection1() {
  // Section1 card data
  const cardData = [
    { image: CutOut, text: "Party CutOuts" },
    { image: TShirt, text: "Custom text Tshirts" },
    { image: Mug, text: "Custom Mugs" },
    { image: Board, text: "Neon light Boards" },
    { image: Frame, text: "Collage Photo Frames" },
  ];

  const leftColRef = useRef(null);
  const rightColRef = useRef(null);

  const [leftInView, setLeftInView] = useState(false);
  const [rightInView, setRightInView] = useState(false);

  // Function to handle scroll
  const handleScroll = () => {
    if (leftColRef.current && rightColRef.current) {
      const leftColPos = leftColRef.current.getBoundingClientRect().top;
      const rightColPos = rightColRef.current.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      // Check if the elements are in view
      if (leftColPos < windowHeight * 0.75) {
        setLeftInView(true);
      }
      if (rightColPos < windowHeight * 0.75) {
        setRightInView(true);
      }
    }
  };
  // Event Listner
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <Container className="p-0 my-3">
        <h2 className="py-4 fw-bold text-center">Popular Products</h2>
        {/* 1st row */}
        <Row>
          <ImageSlider cardData={cardData} />
        </Row>

        {/* 2nd row */}
        <Row className="align-items-center mt-5">
          {/* Left Side */}
          <AnimatedLeftCol
            xs={12}
            md={6}
            className="text-center pr-0"
            $inView={leftInView}
            ref={leftColRef}
          >
            <img
              src={Frame2}
              alt="frame pic"
              className="img-fluid w-100"
              style={{ height: "400px", objectFit: "cover" }}
            />
          </AnimatedLeftCol>

          {/* Right Side */}
          <AnimatedRightCol
            xs={12}
            md={6}
            className="d-flex flex-column justify-content-center"
            $inView={rightInView}
            ref={rightColRef}
            style={{
              backgroundColor: "#f2f2f0",
              height: "400px",
            }}
          >
            <div className="text-center">
              <h2 className="fw-bold">
                Personalized Dad - custom text and photo
              </h2>
              <p>
                You want to show your love back to your Father - an
                unconditional love. Our Dad Custom Photo & Text Canvas Wall Art
                can help you do the job in the simplest but most affectionate
                way.
              </p>
            </div>
          </AnimatedRightCol>
        </Row>

        {/* Divider-line */}
        <hr className="divider-line" style={{ margin: "0 auto" }} />
      </Container>
    </>
  );
}

export default HomeSection1;
